import FactorSpendActivity from "./FactorSpendActivity";
import FactorSpendActivityPopup from "./FactorSpendActivityPopup";

export default FactorSpendActivity;

export { FactorSpendActivityPopup };
